/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbEntitecentreDto } from './FcbEntitecentreDto';
import {
    FcbEntitecentreDtoFromJSON,
    FcbEntitecentreDtoFromJSONTyped,
    FcbEntitecentreDtoToJSON,
} from './FcbEntitecentreDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbEntitecentreDtoPaginatedResults
 */
export interface FcbEntitecentreDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbEntitecentreDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbEntitecentreDto>}
     * @memberof FcbEntitecentreDtoPaginatedResults
     */
    results?: Array<FcbEntitecentreDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbEntitecentreDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbEntitecentreDtoPaginatedResults interface.
 */
export function instanceOfFcbEntitecentreDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbEntitecentreDtoPaginatedResultsFromJSON(json: any): FcbEntitecentreDtoPaginatedResults {
    return FcbEntitecentreDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbEntitecentreDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbEntitecentreDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbEntitecentreDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbEntitecentreDtoPaginatedResultsToJSON(value?: FcbEntitecentreDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbEntitecentreDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

